import apiClient from './client';
import { HistoryEventsResponse, HistorySnapshotResponse } from '../types/history';

export interface HistoryEventsParams {
  x_min: number;
  y_min: number;
  x_max: number;
  y_max: number;
  from: string;   // RFC3339
  to: string;     // RFC3339
  limit?: number;
  offset?: number;
}

export interface HistorySnapshotParams {
  x_min: number;
  y_min: number;
  x_max: number;
  y_max: number;
  at: string;     // RFC3339
}

export const getHistoryEvents = (params: HistoryEventsParams) =>
  apiClient.get<HistoryEventsResponse>('/history/events', { params });

export const getHistorySnapshot = (params: HistorySnapshotParams) =>
  apiClient.get<HistorySnapshotResponse>('/history/snapshot', { params });

export interface HistoryHistogramParams {
  x_min: number;
  y_min: number;
  x_max: number;
  y_max: number;
  from: string;
  to: string;
  buckets?: number;
}

export interface HistoryHistogramResponse {
  from: string;
  to: string;
  buckets: number;
  hist: { b: number; n: number }[];
}

export const getHistoryHistogram = (params: HistoryHistogramParams) =>
  apiClient.get<HistoryHistogramResponse>('/history/histogram', { params });
